let tweets = [
    {
        profileName: "Abderrahmane",
        profilePicUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSowgVxIAnJaW5Gm9LhEtd6Y7yqnwWBDkxaGxo3wzpPbz984M4xPLCQ-fEN2frsDnvpCJg&usqp=CAU",
        username: "Abderrahmane_br",
        isVerified: true,
        description: "My first time using Sass :",
        media: "https://wompampsupport.azureedge.net/fetchimage?siteId=7575&v=2&jpgQuality=100&width=700&url=https%3A%2F%2Fi.kym-cdn.com%2Fentries%2Ficons%2Fmobile%2F000%2F033%2F046%2Fb94.jpg",
        likes: 23,
        comments: 15,
        retweets: 7,
    },
    {
        profileName: "Docker",
        profilePicUrl: "https://pbs.twimg.com/profile_images/1491922873275105290/cJX1HgMT_bigger.jpg",
        username: "Docker",
        isVerified: true,
        description: "Cross - platform image tips plus #Docker hacks and favorite  https://dockr.ly/3zWxxDA commands — Find all this and more in our latest Take 5 featuring #Captain @jmaitrehenry: https://dockr.ly/3zWxxDA",
        media: "https://pbs.twimg.com/media/FZZjgI7XgAEFDsl?format=jpg&name=small",
        likes: 23,
        comments: 15,
        retweets: 7,
    },
    {
        profileName: "Google Cloud Tech",
        profilePicUrl: "https://pbs.twimg.com/profile_images/1219725421962571779/_qstUQx__bigger.jpg",
        username: "GoogleCloudTech",
        isVerified: true,
        description: `We’re back. Join us for #GoogleCloudNext October 11-13.

This year, we're kicking off Next with 24 hours of live content broadcasting from five cities around the globe—from Sunnyvale & New York to Munich & Bengaluru.

Register now → https://goo.gle/3IPP96W`,
        media: "https://pbs.twimg.com/media/FYHm1r2XwAEJaPQ?format=png&name=900x900",
        likes: 23,
        comments: 15,
        retweets: 7,
    },

]

export { tweets };